import * as z from "zod";

export namespace EvidenceId {
	export const kinds = [
		"account",
		"application_extraction",
		"bond",
		"bond_request",
		"bond_request_extraction",
		"bonding_line",
		"contract_extraction",
		"credit_pull",
		"file",
		"financial_extraction",
		"follower",
		"indemnification",
		"indemnity_agreement",
		"ofac_check",
		"party",
		"period",
		"statement",
		"tag",
		"underwriting",
		"wip_extraction",
		"wip_line_item",
		"wip_project",
		"wip_statement",
	] as const;

	export const schema = z.templateLiteral([z.enum(kinds), ":", z.uuid()]);

	export const of = (kind: (typeof kinds)[number], id: string): EvidenceId =>
		schema.parse(`${kind}:${id}`);
}
export type EvidenceId = z.infer<typeof EvidenceId.schema>;
